import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'dateTimeDifference'
})
export class DateTimeDifferencePipe implements PipeTransform {
  formattedDifference: any;

  transform(value:any, type:any) {
    const now = new Date().getTime();
    if (!value) return;
    const pipe = new DatePipe('en-US');
    if(value.includes(' ')){
      value = value.replace(' ','T');
      value = value + 'Z';
    }
    let format;
    if (type == 'hypenDate') {
      format = pipe.transform(value, 'dd-MM-yyyy');
    } else if (type == 'dateTime') {
      const date = pipe.transform(value, 'dd/MMM/yyyy');
      const time = pipe.transform(value, 'hh:mm a');
      const createdDate = new Date(value).getTime();
      const timeDifference = now - createdDate

      const secondsDifference = Math.floor(timeDifference / 1000);
      const minutesDifference = Math.floor(secondsDifference / 60);
      const hoursDifference = Math.floor(minutesDifference / 60);
      const daysDifference = Math.floor(hoursDifference / 24);
      const monthDifference = Math.floor(daysDifference / 30);
      const yearsDifference = Math.floor(monthDifference / 12);

      if (yearsDifference > 0) {
        format =  yearsDifference === 1 ? `1 year ago (${time} ${date})` : `${yearsDifference} years ago (${time} ${date})`;
      } else if (monthDifference > 0){
        format =  monthDifference === 1 ? `1 month ago (${time} ${date})` : `${monthDifference} months ago (${time} ${date})`;
      } else if (daysDifference > 0){
        format =  daysDifference === 1 ? `1 day ago (${time} ${date})` : `${daysDifference} days ago (${time} ${date})`;
      } else if (hoursDifference > 0) {
        format = hoursDifference === 1 ? `1 hour ago (${time} ${date})` : `${hoursDifference} hours ago (${time} ${date})`;
      } else if (minutesDifference > 0) {
        format = minutesDifference === 1 ? `1 minute ago (${time} ${date})` : `${minutesDifference} minutes ago (${time} ${date})`;
      } else {
        format = secondsDifference === 1 ? `1 second ago (${time} ${date})` : `${secondsDifference} seconds ago (${time} ${date})`;
      }
    } else {
      return;
    }
    return format;
  }

}
